module.exports = __webpack_public_path__ + "img/office-cards-en.20999fa7.jpg";